import React, { FC, useState, useEffect } from 'react';
import { useNavigate } from 'react-router';
import { isNowAndNext } from 'utils/fnTypeGuards';
import { getLivePlayerURL } from 'utils/fnUrl';
import { usePlayer } from 'providers/player/PlayerContext';
import { useNowAndNextQuery } from 'providers/useLiveNowData/useNowAndNextQuery';
import { PlayingMode } from 'types/Player';
import { Slider } from '../Slider/Slider';
import { SliderWrapper } from '../Slider/Slider.css';
import { styled } from '../ThemeConfigConnector/ThemeConfigConnnector';
import { ControlGroup } from '../Player/PlayerWrapper';

type PropTypes = {
    currentChannel: string;
    activeGroup: ControlGroup;
};

const MiniEpgWrapper = styled.div`
    ${SliderWrapper} {
        padding-bottom: 0;
        padding-top: 0;
    }
`;

const MINI_EPG_TITLE = 'MINI_EPG_TITLE';

export const MiniEpg: FC<PropTypes> = ({ currentChannel }) => {
    const [initialScrollPosition, setInitialScrollPosition] = useState<number | null>(null);
    const navigate = useNavigate();
    const { setPlayingMode } = usePlayer();
    const { items: liveNowItems, isLoading } = useNowAndNextQuery();

    useEffect(() => {
        if (!currentChannel || !liveNowItems?.length) return;

        const position = liveNowItems.findIndex((item) => item.channelId === currentChannel);
        setInitialScrollPosition(position >= 0 ? position : null);
    }, [currentChannel, liveNowItems]);

    if (!liveNowItems?.length) {
        return null;
    }

    const handleCardClick = (_event: React.MouseEvent, data: unknown) => {
        if (isNowAndNext(data)) {
            if (!data.isChannelSubscribed) return;
            setPlayingMode(PlayingMode.NORMAL);
            navigate(getLivePlayerURL(data.channelId), { replace: true, state: { channelSwitch: true } });
        }
    };

    return (
        <MiniEpgWrapper>
            <Slider
                title={MINI_EPG_TITLE}
                assets={liveNowItems}
                isLoading={isLoading}
                stripePosition={-1}
                screenName={''}
                onCardClick={handleCardClick}
                expandable={true}
                hasMoreAssets={true}
                miniEpg={true}
                initScrollTo={initialScrollPosition}
            />
        </MiniEpgWrapper>
    );
};
